import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    clearSelectedLibraryBranch(userId: number): void {
        if (!userId){
            return;
        }
        [this.getKeyBranch(userId), this.getKeyLibrary(userId)].forEach((key) => localStorage.removeItem(key));
    }

    getSelectedBranch(userId: number): string | undefined {
        if (!userId){
            return;
        }
        const value = localStorage.getItem(this.getKeyBranch(userId));
        return value ?? undefined;
    }

    getSelectedLibrary(userId: number): number | undefined  {
        if (!userId){
            return;
        }
        const value = localStorage.getItem(this.getKeyLibrary(userId));
        const parsed = parseInt(value, 10);
        return isNaN(parsed) ? undefined : parsed;
    }

    setSelectedBranch(userId: number, branchAbbr: string): void {
        if (!userId || !branchAbbr){
            return;
        }
        localStorage.setItem(this.getKeyBranch(userId), branchAbbr);
    }

    setSelectedLibrary(userId: number, libraryId: number): void {
        if (!userId || !libraryId){
            return;
        }
        localStorage.setItem(this.getKeyLibrary(userId), libraryId.toString());
    }

    private getKeyLibrary(userId: number): string {
        return `currentLibrary${userId}`;
    }

    private getKeyBranch(userId: number): string {
        return `currentBranch${userId}`;
    }
}
